import { App } from '@ps20-frontend/frontend-models';

export const orderProductList = [
  App.PH,
  App.VHV,
  App.VHV_V2,
  App.RS,
  App.RS_VERMIETUNG,
  App.VWG,
  App.VWG_V2,
  App.UNF,
  App.THH_HUND,
  App.THH_PFERD,
  App.TKV,
  App.TKV_V2,
  App.GEGE,
  App.JHP,
];
